/**
 * Notification hook
 *
 * @example
 * ```tsx
 * const { showToast, showModal } = useNotification();
 *
 * showToast('Salvo com sucesso!', 'success');
 *
 * showModal(
 *   'Confirmar exclusão',
 *   'Tem certeza que deseja excluir este item?',
 *   'warning',
 *   {
 *     actions: [
 *       { label: 'Cancelar', variant: 'ghost' },
 *       { label: 'Excluir', variant: 'danger', onClick: handleDelete },
 *     ],
 *   }
 * );
 * ```
 */
export { useNotification } from '@/lib/stores/notification-store';
